import { Box, Button, TextField, Typography } from "@mui/material";
import axios from "axios";
import Cookies from "js-cookie";
import React, { useRef, useState } from "react";
import { Navigate } from "react-router-dom";
import ValidateEmail from "../asset/js/ValidateEmail";
import SimpleBackdrop from "./BackDrop";
import "./settings-modern.css";

export default function ChangeUpdateEmail() {
  const [direct, setDirect] = useState(false);
  const [open, setOpen] = useState(false);
  const [sentOtp, setOtp] = useState("");
  const [next1, setNext1] = useState(false);
  const [next, setNext] = useState(false);
  const [otp, setValue] = useState("");
  const email = useRef("");
  const [validEmail, setValidEmail] = useState(false);

  const handleSubmit1 = () => {
    if (otp.toString() !== sentOtp.toString()) return;
    setOpen(true);
    axios.put(
      `${process.env.React_APP_BACKEND_URL}/api/changeemail`,
      { changeEmail: email.current },
      { headers: { Authorization: `Bearer ${Cookies.get("token")}` } }
    ).then(() => {
      setOpen(false);
      setNext1(true);
      Cookies.set("subscription", "No", { expires: 365 });
      ["favids","token","name","last_name","id","username","email","phone"].forEach((key) => Cookies.remove(key));
    }).catch((err) => {
      setOpen(false);
      console.log(err);
    });
  };

  const handleSubmit = () => {
    setValidEmail(false);
    if (!ValidateEmail(email.current)) { setValidEmail(true); return; }
    setOpen(true);
    axios.get(`${process.env.React_APP_BACKEND_URL}/api/checkemail?email=${email.current}`)
      .then((data1) => {
        if (data1.status === 200) {
          setOtp(data1.data.OTP);
          setOpen(false);
          setNext(true);
          setDirect(true);
        }
      })
      .catch((err) => {
        setOpen(false);
        console.log(err);
        setValidEmail(true);
      });
  };

  if (next1) return <Navigate to="/signin" />;

  return (
    <Box className="bidit-settings-page-card">
      {!next && !direct ? (
        <>
          <Box className="bidit-settings-head">
            <Typography className="bidit-settings-title">כתובת הדוא"ל החדשה</Typography>
            <Typography className="bidit-settings-subtitle">הזינו את הכתובת החדשה. נשלח אליה קוד אימות לפני השמירה.</Typography>
          </Box>
          <Typography className="bidit-settings-field-label">דוא"ל חדש</Typography>
          <TextField fullWidth required onChange={(e) => { email.current = e.target.value; }} id="email" name="email" autoComplete="email" placeholder="name@example.com" />
          {validEmail && <Box className="bidit-settings-error">כתובת הדוא"ל אינה תקינה או שהיא כבר בשימוש.</Box>}
          <Button fullWidth onClick={handleSubmit} variant="contained" className="bidit-settings-primary" sx={{ mt: 2.5 }}>שליחת קוד אימות</Button>
        </>
      ) : (
        <>
          <Box className="bidit-settings-head">
            <Typography className="bidit-settings-title">אימות הדוא"ל החדש</Typography>
            <Typography className="bidit-settings-subtitle">הזינו את הקוד בן 6 הספרות שנשלח לכתובת החדשה.</Typography>
          </Box>
          <Box dir="ltr" sx={{ my: 2, textAlign: "center" }}>
            <input
              className="auth-modern-one-time-code"
              type="text"
              value={otp}
              onChange={(e) => setValue(e.target.value.replace(/\D/g, "").slice(0, 6))}
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={6}
              autoComplete="one-time-code"
              name="one-time-code"
              aria-label="קוד אימות בן 6 ספרות"
              autoFocus
            />
          </Box>
          <Button fullWidth variant="contained" onClick={handleSubmit1} disabled={otp.length !== 6} className="bidit-settings-primary">שמירת כתובת הדוא"ל</Button>
        </>
      )}
      {open && <SimpleBackdrop open={open} setOpen={setOpen} handleClose={() => setOpen(false)} handleToogle={() => setOpen(!open)} />}
    </Box>
  );
}
